"use client";

import { createContext } from "react";
import type { Session } from "@introw/auth";
import { hasPermission } from "@introw/utils/permissions";

type UserInput = Required<Session>["user"];
export type User =
  | (UserInput & {
      permissions: {
        team: boolean;
        portal: boolean;
        templates: boolean;
        integrations: boolean;
        internalSso: boolean;
        isAdmin: boolean;
      };
    })
  | null;

export const UserContext = createContext<User>(null);

export const UserContextProvider = ({ children, user }: { user: UserInput; children: React.ReactNode }) => {
  const value = {
    ...user,
    permissions: {
      isAdmin: user?.teamUserRole?.permissions?.has_all_permissions,
      team: hasPermission(user?.teamUserRole?.permissions || {}, "team_write"),
      templates: hasPermission(user?.teamUserRole?.permissions || {}, "templates_write"),
      integrations: hasPermission(user?.teamUserRole?.permissions || {}, "integrations_write"),
      internalSso: hasPermission(user?.teamUserRole?.permissions || {}, "internalSso_write"),
      portal: hasPermission(user?.teamUserRole?.permissions || {}, "portal_write"),
    },
  } as User;

  return <UserContext.Provider value={user ? value : null}>{children}</UserContext.Provider>;
};
